import styled from "styled-components";

export const PageWrapper = styled.div`
    flex: 1;
`
